// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper: fixed height for vertical scroll */
.data-table-wrapper {
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  --data-table-header-bg: #d7efe0;
  --data-table-header-bg-hover: #c4e6d3;
  --data-table-col-max-width: 360px;
}

/* Inner scroll container: both axes, takes remaining space */
.data-table-scroll {
  overflow: auto;
  min-height: 0;
  flex: 1 1;
  -webkit-overflow-scrolling: touch;
}

/* Table layout */
.data-table {
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.875rem;
  table-layout: auto;
}

/* Sticky header */
.data-table-head {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--data-table-header-bg);
  box-shadow: 0 1px 0 0 #dee2e6;
}

.data-table-th {
  padding: 24px 22px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  max-width: var(--data-table-col-max-width);
  border-bottom: 2px solid #dee2e6;
  background: var(--data-table-header-bg);
}

.data-table-th--center {
  text-align: center;
}

.data-table-th--right {
  text-align: right;
}

.data-table-th--sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.data-table-th--sortable:hover {
  background: var(--data-table-header-bg-hover);
  color: #212529;
}

.data-table-th-content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.data-table-sort-icon {
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
}

.data-table-sort-arrow {
  color: #0d6efd;
}

.data-table-sort-arrow--muted {
  color: #adb5bd;
  opacity: 0.8;
}

/* Body */
.data-table-body .data-table-row:hover {
  background: #f8f9fa;
}

.data-table-body .data-table-row--clickable:hover {
  background: #eef6ff;
}

.data-table-td {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  color: #212529;
  vertical-align: middle;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  max-width: var(--data-table-col-max-width);
}

.data-table-td--center {
  text-align: center;
}

.data-table-td--right {
  text-align: right;
}

.data-table-empty {
  text-align: center;
  padding: 2rem 1rem !important;
  color: #6c757d;
  font-style: italic;
  border-bottom: none;
}

/* Responsive: smaller padding on narrow viewports */
@media (max-width: 768px) {
  .data-table-th,
  .data-table-td {
    padding: 8px 10px;
    font-size: 0.8125rem;
  }
}

/* Optional: striped rows (can be enabled via wrapper class later if needed) */
.data-table-wrapper.data-table--striped
  .data-table-body
  .data-table-row:nth-child(even) {
  background: #fafafa;
}

.data-table-wrapper.data-table--striped
  .data-table-body
  .data-table-row:nth-child(even):hover {
  background: #f1f3f5;
}
`, "",{"version":3,"sources":["webpack://./src/components/DataTable/DataTable.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,aAAa;EACb,SAAO;EACP,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA,8EAA8E;AAC9E;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB","sourcesContent":["/* Wrapper: fixed height for vertical scroll */\n.data-table-wrapper {\n  overflow: hidden;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  --data-table-header-bg: #d7efe0;\n  --data-table-header-bg-hover: #c4e6d3;\n  --data-table-col-max-width: 360px;\n}\n\n/* Inner scroll container: both axes, takes remaining space */\n.data-table-scroll {\n  overflow: auto;\n  min-height: 0;\n  flex: 1;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Table layout */\n.data-table {\n  width: 100%;\n  min-width: max-content;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 0.875rem;\n  table-layout: auto;\n}\n\n/* Sticky header */\n.data-table-head {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--data-table-header-bg);\n  box-shadow: 0 1px 0 0 #dee2e6;\n}\n\n.data-table-th {\n  padding: 24px 22px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  max-width: var(--data-table-col-max-width);\n  border-bottom: 2px solid #dee2e6;\n  background: var(--data-table-header-bg);\n}\n\n.data-table-th--center {\n  text-align: center;\n}\n\n.data-table-th--right {\n  text-align: right;\n}\n\n.data-table-th--sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.data-table-th--sortable:hover {\n  background: var(--data-table-header-bg-hover);\n  color: #212529;\n}\n\n.data-table-th-content {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.data-table-sort-icon {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.75rem;\n}\n\n.data-table-sort-arrow {\n  color: #0d6efd;\n}\n\n.data-table-sort-arrow--muted {\n  color: #adb5bd;\n  opacity: 0.8;\n}\n\n/* Body */\n.data-table-body .data-table-row:hover {\n  background: #f8f9fa;\n}\n\n.data-table-body .data-table-row--clickable:hover {\n  background: #eef6ff;\n}\n\n.data-table-td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #eee;\n  color: #212529;\n  vertical-align: middle;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  max-width: var(--data-table-col-max-width);\n}\n\n.data-table-td--center {\n  text-align: center;\n}\n\n.data-table-td--right {\n  text-align: right;\n}\n\n.data-table-empty {\n  text-align: center;\n  padding: 2rem 1rem !important;\n  color: #6c757d;\n  font-style: italic;\n  border-bottom: none;\n}\n\n/* Responsive: smaller padding on narrow viewports */\n@media (max-width: 768px) {\n  .data-table-th,\n  .data-table-td {\n    padding: 8px 10px;\n    font-size: 0.8125rem;\n  }\n}\n\n/* Optional: striped rows (can be enabled via wrapper class later if needed) */\n.data-table-wrapper.data-table--striped\n  .data-table-body\n  .data-table-row:nth-child(even) {\n  background: #fafafa;\n}\n\n.data-table-wrapper.data-table--striped\n  .data-table-body\n  .data-table-row:nth-child(even):hover {\n  background: #f1f3f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
